export default __webpack_public_path__ + "static/blogThumbnail(6)-26319cd8dea6b23408335fc89f3e8c8a.png";